import { render, staticRenderFns } from "./cart-button.vue?vue&type=template&id=3659df66&"
import script from "./cart-button.vue?vue&type=script&lang=js&"
export * from "./cart-button.vue?vue&type=script&lang=js&"
import style0 from "./cart-button.vue?vue&type=style&index=0&id=3659df66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports